export class EntityIdListQueryApiModel {
  ids: number[];
}
